/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
/** App imports */
import { ValidatorProps } from '../../TypeScript/interfaces';
import { appContext } from '../../Contexts/AppContext';
import { getCompany } from '../authenticated-requests/company';
import Forbidden from '../../Components/403';
import { useIsInternalUser } from '../helpers';
import { INTERNAL_CO } from '../constants';

/**
 * Validate that the user is admin, else navigate away
 * @param props standard validator props
 * @returns child component with validation applie
 */
const CompanyValidator: React.FC<ValidatorProps> = (
  props: React.PropsWithChildren<ValidatorProps>,
): JSX.Element => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { company, setCompany, setAppLoading } = useContext(appContext);
  const isInternalUser: boolean = useIsInternalUser();
  const [isValidCompanyId, setIsValidCompanyId] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    // handles '/' path
    if (!companyId) {
      navigate(`/${company}`);
    }
    // handles switch company with url
    if (companyId !== company) {
      validateCompanyId(companyId || '');
    }
  }, [companyId]);

  const validCompany = async (companyId: string): Promise<boolean> => {
    setAppLoading(true);
    try {
      const response = await getCompany(companyId);
      return !!response.company;
    } catch (error) {
      return false;
    } finally {
      setAppLoading(false);
    }
  };

  const validateCompanyId = async (companyId: string) => {
    if (
      companyId &&
      isInternalUser &&
      (companyId === INTERNAL_CO ||
        (companyId !== INTERNAL_CO && (await validCompany(companyId))))
    ) {
      setIsValidCompanyId(true);
      setCompany(companyId);
    } else {
      setIsValidCompanyId(false);
    }
  };

  return (
    <>
      {company && companyId === company && props.children}
      {isValidCompanyId === false && companyId && companyId !== company && (
        <Forbidden />
      )}
    </>
  );
};

export default CompanyValidator;
